const SHARE_TEXT = {
    UPPER: [
        `Yay! When we launch, we’ll send you a code for a free capsule of Pzaz. Want to spread the positive energy?`
    ],
    LINK: 'TAP TO SHARE',
    LOWER: `For every friend who plays, we'll pick up and recycle one more pound of plastic litter.`
}

export {SHARE_TEXT}